<template>
  <div class="list-view product-checkout mt-0" v-if="option !== 1">
    <div class="checkout-options">
      <b-card v-if="payment" class="body-padding">
        <b-card-header class="p-0">
          <b-card-title>
            <h4 class="text-start">{{ `${$t(label("status"))}` }}</h4>
          </b-card-title>
          <b-button
            :aria-expanded="visible ? 'true' : 'false'"
            @click="visible = !visible"
            variant="flat-dark"
            class="btn-icon"
            size="sm"
            :class="visible ? null : 'collapsed'"
          >
            <feather-icon
              :icon="visible ? 'EyeOffIcon' : 'EyeIcon'"
              size="21"
            />
          </b-button>
        </b-card-header>

        <b-collapse id="detail-status" v-model="visible" class="mt-2">
          <div class="price-details">
            <b-row>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="status">
                <v-select
                  ref="status"
                  v-model="localStatus"
                  :options="listOrderStatus"
                  input-id="status"
                  label="name"
                  class="mt-1"
                  :placeholder="$t(label('status_order'))"
                  :reduce="(option) => option.id"
                  @input="changeOrderStatus"
                >
                  <span slot="no-options" click="$refs.status.open = false">{{
                    $t("sorryOption")
                  }}</span>
                </v-select>
              </b-col>
              <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                <b-button
                  :disabled="disabledButton"
                  variant="primary"
                  block
                  @click="updatesOrderStatus(payment)"
                  class="mt-1"
                >
                  {{ $t(label("update")) }}
                </b-button>
              </b-col>
            </b-row>
            <!--             
            <h6>{{ $t(label('detail_pay')) }}</h6>
            <hr />
            <ul v-for="(pymentList, index) in payment" :key="index" class="list-unstyled">

              <li class="price-detail">
                <div class="detail-title">{{ $t(label('type_payment')) }}</div>
                <div class="detail-amt">{{ pymentList.typePayment }}</div>
              </li>

              <li class="price-detail">
                <div class="detail-title">{{ $t(label('reference')) }}</div>
                <div class="detail-amt">{{ pymentList.reference }}</div>
              </li>

              <li class="price-detail">
                <div class="detail-title">Foto</div>
                <div class="detail-amt">{{ pymentList.informationPayment }}</div>
              </li>

              <li class="price-detail">
                <div class="detail-title">{{ $t(label('url_reference')) }}</div>
                <div class="detail-amt">{{ pymentList.urlReference }}</div>

                <b-col v-if="option != 2" cols="12" sm="6" md="6" lg="6" xl="6"
                  class="d-flex align-items-center justify-content-center">
                  <b-form-group :label="$t(label('logo'))" label-for="inputFilePhoto">
                    <b-media class="body-style">
                      <div v-if="!pymentList.urlReference && option != 2">
                        <input id="inputFilePhoto" ref="fileInputPhoto" name="inputFilePhoto" type="file" class="hidden"
                          accept=".png,.peg,.jpg,.jpeg" @change="onFileChange($event, 'urlReference')" />
                        <div
                          class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                          accept=".png,.peg,.jpg,.jpeg" @drop="handleDrop($event, 'urlLogo')" @dragover="handleDragover"
                          @dragenter="handleDragover" @click="$refs.fileInputPhoto.click()">
                          <feather-icon icon="UploadCloudIcon" size="20"
                            svg-classes="h-16 w-16 stroke-current text-grey" />
                          <span style="margin-left: 5px" @click.stop="$refs.fileInputPhoto.click()">Subir imagen
                          </span>
                        </div>
                      </div>
                      <template v-if="pymentList.urlLogo" #aside>
                        <div class="image-full-screen">
                          <img id="image" ref="image" :src="pymentList.urlLogo" class="img-avatar border-dashed" />
                        </div>
                        <div v-if="pymentList.urlLogo && option != 2" class="d-flex flex-wrap" style="width: 10px">
                          <b-button variant="primary" style="height: 30px; width: 30px; padding: 4px"
                            @click="deleteFile('urlLogo')">
                            <feather-icon icon="XIcon" size="21" />
                          </b-button>
                        </div>
                      </template>
                    </b-media>
                  </b-form-group>
                </b-col>
              </li>
              <hr />
            </ul> -->
            <!-- <hr /> -->
            <!-- <ul class="list-unstyled">

              <li v-for="(pymentList, index) in payment" :key="index+1" class="price-detail">
                <div class="detail-title">{{ $t(label('total_products')) }}</div>
                <div class="detail-amt">{{ pymentList.amount }} {{ divisa }}</div>
              </li>
              <li v-for="(pymentList, index) in payment" :key="index+3" class="price-detail">
                <div class="detail-title">{{ $t(label('total_local')) }}</div>
                <div class="detail-amt">{{ roundedNumber(pymentList.amountVES) }} Bs</div>
              </li>
              <li v-if="shipping" class="price-detail">
                <div class="detail-title">{{ $t(label('delivery')) }}</div>
                <div class="detail-amt discount-amt">{{ shipping.nameOfPersonSending }}</div>
              </li>

              <li v-if="shipping" class="price-detail">
                <div class="detail-title">{{ $t(label('total_delivery')) }}</div>
                <div class="detail-amt discount-amt" :class="{ 'text-success': !shipping }">{{ (shipping ? (shipping.amount +
          '' + divisa) : 'Free') }}</div>
              </li>
            </ul> -->
            <!-- <hr /> -->
            <!-- <ul class="list-unstyled" v-if="ves">
              <li class="price-detail" ref="ves">
                <div class="detail-title detail-total">Costo total a pagar en Bs</div>
                <div class="detail-amt font-weight-bolder">
                  {{ roundedNumber(totalToVES) }} {{ divisa }}
                </div>
              </li>
            </ul>
            <ul class="list-unstyled" v-if="pay">
              <li class="price-detail" ref="pay">
                <div class="detail-title detail-total">Costo total a pagar</div>
                <div class="detail-amt font-weight-bolder">
                  {{ totalToPay }} {{ divisa }}
                </div>
              </li>
            </ul> -->
          </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCardHeader,
  BCardTitle,
  BButton,
  BCard,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BRow,
  BCol,
  BToast,
  BMedia,
  BFormGroup,
  BCollapse,
  VBToggle,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import DetailProducts from "./DetailProducts.vue";
import { getCatalog, postFile } from "@core/api/request/catalogs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { changeStatus } from "@core/api/request/orders";

export default {
  components: {
    BCardHeader,
    BCardTitle,
    BButton,
    BCard,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BRow,
    BCol,
    vSelect,
    BToast,
    DetailProducts,
    BMedia,
    BFormGroup,
    BCollapse,
    VBTooltip,
  },
  props: {
    option: {
      type: Number,
      default: () => 1,
    },
    blockStatus: {
      type: Boolean,
      default: () => false,
    },
    payment: {
      type: Array,
      default: () => [],
    },
    shipping: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Number,
      default: 0,
    },
    ves: {
      type: Number,
      default: 0,
    },
    pay: {
      type: Number,
      default: 0,
    },
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip },

  data: () => ({
    visible: true,
    listOrderStatus: [],
    companyGuid: null,
    localStatus: null,
    totalToVES: 0,
    totalToPay: 0,
    disabledButton: false,
    loadingPhoto: false,
  }),
  computed: {
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
  },
  watch: {
    status(a, b) {
      this.localStatus = a;
    },
    ves(a, b) {
      this.totalToVES = a;
    },
    pay(a, b) {
      this.totalToPay = a;
    },
  },
  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.showCatalog();
  },

  async mounted() {},

  methods: {
    colorStatus(status) {
      switch (status) {
        case "Generada":
          return "secondary";
        case "Atendida":
          return "warning";
        case "Procesada":
          return "info";
        case "Terminada":
          return "success";
        case "Cancelada":
          return "danger";
        default:
          return "primary";
      }
    },

    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },

    roundedNumber(value) {
      // console.log('Valor a redondear', value)
      return value?.toFixed(2);
    },

    changeOrderStatus(value) {
      this.localStatus = value;
    },

    updatesOrderStatus(item) {
      this.disabledButton = true;
      if (!this.localStatus) {
        this.alertToast(
          "danger",
          `Alerta`,
          "Debes seleccionar un estado para actualizar",
        );
        this.disabledButton = false;
        return;
      }
      const data = {
        idOrder: item[0].idOrder,
        idCatStatus: this.localStatus,
      };

      changeStatus(data)
        .then((resp) => {
          console.log(resp);
          if (resp.status === 500) {
            this.alertToast("danger", `Alerta`, resp.data.message);
            this.disabledButton = false;
            return;
          }

          this.alertToast("success", `Alerta codigo`, resp.data);
          this.disabledButton = false;
          this.$emit("changeorder");
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    totalPay(shipping, payment) {
      return shipping ? payment.amount + shipping.amount : payment.amount;
    },

    showCatalog() {
      showLoading();
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,1a9be8bf-50d7-41b6-b33c-594b0699b1a9`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data") || [];
          this.listOrderStatus = data.listOfItems.items;
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    // FUNTIONS FOR REFERECE FILE

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.company[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    handleDrop(e, field) {
      e.stopPropagation();
      e.preventDefault();
      const { files } = e.dataTransfer;
      if (files.length !== 1) {
        return;
      }
      const accept =
        e.target.getAttribute("accept") ||
        e.target.parentElement.getAttribute("accept");
      const multiple =
        e.target.getAttribute("multiple") ||
        e.target.parentElement.getAttribute("multiple");
      this.onTransFile(files, accept, multiple, field);
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    deleteFile(field) {
      this.payment[field] = null;
    },
  },
};
</script>

<style lang="scss">
.body-padding {
  .card-body {
    padding: 1.5rem;
  }
}
</style>
